var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"gl-text-sm gl-text-subtle"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('user-avatar-list',{staticClass:"gl-ml-2",attrs:{"items":_vm.users,"img-size":16}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }